import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput as Checkbox } from '@capsicum/common-web';
import { useLatestAcceptedAgreement } from '@capsicum/features/account/shared';
import { useAmlTermsAndConditions } from '@capsicum/features/regulations/shared';

import * as S from './AmlQuestionnaire.styled';

export const TermsAndConditions = () => {
	const { $t } = useIntl();
	const { latestAcceptedAgreementLink } = useLatestAcceptedAgreement();
	const { onChange } = useAmlTermsAndConditions();

	return (
		<S.Wrapper>
			<S.Title>{$t('amlQuestionnaire.startStep.title')}</S.Title>
			<S.Subtitle>{$t('amlQuestionnaire.startStep.subtitle')}</S.Subtitle>
			<S.RegulatoryText>
				{$t<JSX.Element>('amlQuestionnaire.startStep.text2', {
					link: chunks => (
						<S.Link
							data-testid="start-question-terms-link"
							href={latestAcceptedAgreementLink || ''}
							target="_blank"
						>
							{chunks}
						</S.Link>
					)
				})}
			</S.RegulatoryText>
			<Checkbox testID="aml-questionnaire-terms-and-conditions-checkbox" value={false} onChange={onChange}>
				<S.CheckboxText>{$t('amlQuestionnaire.startStep.confirmMessage')}</S.CheckboxText>
			</Checkbox>
		</S.Wrapper>
	);
};
